export default function outboundReducer(outbound, action) {
  switch (action.type) {
    case "set":
      return action.value;

    case "addPrefix":
      return { ...outbound, destinationPrefixes: [...outbound.destinationPrefixes, action.prefix] };
    case "updatePrefix":
      return {
        ...outbound,
        destinationPrefixes: outbound.destinationPrefixes.map((_destinationPrefix) => {
          if (_destinationPrefix.id === action.prefix.id) {
            _destinationPrefix = action.prefix;
          }
          return _destinationPrefix;
        }),
      };
    case "deletePrefix":
      return {
        ...outbound,
        destinationPrefixes: outbound.destinationPrefixes.filter(
          (_destinationPrefix) => _destinationPrefix.id !== action.prefix.id,
        ),
      };

    default:
      return { ...outbound, [action.type]: action.value };
  }
}
